"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._ClassNames = void 0;
exports._ClassNames = {
    errorfield: 'fittec-form-error',
    toastmessage: 'fittec-toast-message',
    successfield: 'fittec-success-error',
};
